export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiY2xpcHB5Ljg5YmQ0OGNiYTFhMThkMDE2NDViMDA2YjU5YTgzMDI2LnN2ZyI7"